import React, { useRef } from 'react';
import {
  useFirebaseContext,
  useAllInOneContext,
  useActiveListContext,
} from '../../../context';
import { handleClickOutside } from '../../../hooks';
import { DEFAULT_LIST, COLORS_L2 } from '../../../constants';
import { timestamp } from '../../../lib';
import { DeleteBox } from './styles';

export const DeleteList = ({ setShowBox, list, setProgress, setIsInDelete }) => {
  const wrapperRef = useRef();
  const { firebase } = useFirebaseContext();
  const {
    lists,
    setLists,
    allTasks,
    setAllTasks,
    setMaxModifiedAt,
  } = useAllInOneContext();
  const { activeList, setActiveList } = useActiveListContext();

  handleClickOutside(wrapperRef, { setShowBox });

  const deleteList = (docID) => {
    const db = firebase
      .firestore()
      .collection('users')
      .doc(firebase.auth().currentUser.uid);

    const taskDB = db.collection('tasks');
    const toRemove = allTasks.filter((task) => task.listID == docID);
    toRemove.map((task) => {
      taskDB.doc(task.docID).delete();
    });
    setProgress(20);

    setAllTasks(allTasks.filter((el) => !toRemove.includes(el)));
    setProgress(40);

    const listDB = db.collection('lists');
    const targetOrder = list.order;
    const tempModifiedAt = timestamp.now().toMillis();
   
    listDB
      .doc(docID)
      .delete()
      .then(() => {
        setProgress(60);
        let temp = lists.filter((item) => item.docID != docID);
        temp.map((doc) => {
          if (doc.order > targetOrder) {
            const newOrder = doc.order - 1;

            listDB.doc(doc.docID).update({
              order: newOrder,
              modifiedAt: tempModifiedAt,
            });

            doc.order = newOrder;
          }
        });

        if (docID == activeList) {
          setActiveList();
          setActiveList(DEFAULT_LIST);
        }
        setProgress(80);

        setLists(temp);
        setProgress(100);
        setIsInDelete(false);
        setMaxModifiedAt(tempModifiedAt);
      });
  };

  return (
    <DeleteBox color={COLORS_L2[list.color]}>
      <div className='container' ref={wrapperRef}>
        <span className='question'>
          Are you sure you want to delete this list?
        </span>
        <div className='button-box'>
          <div
            className='button-confirm button'
            type='button'
            onClick={() => {
              setIsInDelete(true);
              deleteList(list.docID);
            }}
          >
            Confirm
          </div>
          <div
            className='button-cancel button'
            onClick={() => setShowBox(false)}
          >
            Cancel
          </div>
        </div>
      </div>
    </DeleteBox>
  );
};
